module.exports = __webpack_public_path__ + "static/media/nodejs-logo.46f75866.png";